import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import MobileLayout from '../../components/MobileLayout';
import { useAvatars } from '../../../hooks/useApi';
import './MobileSelectAvatar.css';

const IconUser   = () => <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const IconPlus   = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IconCheck  = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>;
const IconSearch = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>;

export default function MobileSelectAvatar() {
  const navigate = useNavigate();
  const location = useLocation();

  const [search, setSearch]       = useState('');
  const [page, setPage]           = useState(1);
  const [selected, setSelected]   = useState(null);

  const returnTo = location.state?.from || '/m/generate';

  const { avatars, loading, error, totalPages, refetch } = useAvatars('my', page, search);

  // Pre-select the currently chosen avatar
  useEffect(() => {
    try {
      const saved = localStorage.getItem('selectedAvatar');
      if (saved) setSelected(JSON.parse(saved));
    } catch {}
  }, []);

  const handleSelect = (avatar) => {
    localStorage.setItem('selectedAvatar', JSON.stringify(avatar));
    navigate(returnTo, { replace: true });
  };

  const handleCreateNew = () => {
    navigate('/m/create-avatar', { state: { from: location.pathname, returnTo } });
  };

  return (
    <MobileLayout title="选择形象" showBack>
      <div className="msa-root">
        {/* Search */}
        <div className="msa-search-wrap">
          <span className="msa-search-icon"><IconSearch /></span>
          <input
            className="msa-search"
            type="search"
            placeholder="搜索形象名称..."
            value={search}
            onChange={(e) => { setSearch(e.target.value); setPage(1); }}
          />
        </div>

        {loading && page === 1 ? (
          <div className="msa-loading"><div className="msa-spinner" /></div>
        ) : error ? (
          <div className="msa-error">{error} <button onClick={() => refetch()}>重试</button></div>
        ) : (
          <>
            <div className="msa-grid">
              {/* Create new card always at top */}
              <div className="msa-create-card" onClick={handleCreateNew}>
                <div className="msa-create-icon"><IconPlus /></div>
                <div className="msa-create-label">创建新形象</div>
                <div className="msa-create-hint">上传视频，训练专属数字人</div>
              </div>

              {avatars.map((avatar) => {
                const isSelected = selected?.id === avatar.id;
                return (
                  <div
                    key={avatar.id}
                    className={`msa-card${isSelected ? ' selected' : ''}`}
                    onClick={() => handleSelect(avatar)}
                  >
                    <div className="msa-thumb">
                      {avatar.thumbnail
                        ? <img src={avatar.thumbnail} alt={avatar.name} loading="lazy" />
                        : <IconUser />
                      }
                    </div>
                    <div className="msa-card-body">
                      <div className="msa-card-name">{avatar.name}</div>
                      {avatar.createdAt && (
                        <div className="msa-card-meta">{avatar.createdAt}</div>
                      )}
                    </div>
                    {isSelected && (
                      <div className="msa-check"><IconCheck /></div>
                    )}
                  </div>
                );
              })}

              {/* Empty state when no avatars (but show create card above) */}
              {avatars.length === 0 && !loading && (
                <div style={{ gridColumn: '1/-1', textAlign: 'center', color: '#9ca3af', fontSize: 13, paddingTop: 8 }}>
                  {search ? '没有匹配的形象' : '还没有数字人形象，创建一个吧'}
                </div>
              )}
            </div>

            {/* Load more */}
            {totalPages > page && (
              <div className="msa-load-more">
                <button
                  className="msa-load-more-btn"
                  onClick={() => setPage((p) => p + 1)}
                  disabled={loading}
                >
                  {loading ? '加载中...' : '加载更多'}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </MobileLayout>
  );
}
